import React from 'react';
import { gearTypes, gearTypeVideos } from '../data';

interface GearVideoProps {
  gearTypeId: string;
}

const GearVideo: React.FC<GearVideoProps> = ({
  gearTypeId,
}) => {

  const gearType = gearTypes[gearTypeId];
  const videoSrc = gearTypeVideos[gearType];

  return (
    <>

      <div className="gear-type-video-container">
        {videoSrc &&
          <video
            key={videoSrc}
            width="320"
            height="240"
            autoPlay
            playsInline
            loop
            muted
          >
            <source src={videoSrc} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        }
      </div>
    </>

  )
};

export default GearVideo;
